export default __webpack_public_path__ + "static/media/subscription_analytics_img.76d0891e.png";